import BaseProxy from "../../base-proxy";

export default class GetSleekSignUserDetailByEmailProxy {
  /**
   * @async
   * @function getByEmail
   * @description Method used for retrieving users by email.
   * @param {Object} params - Request object.
   * @param {String} params.email - Email of target user.
   */
  async getByEmail(params = {}) {
    const baseProxy = new BaseProxy();
    try {
      const apiURL = await baseProxy.getSleekSignBackendUrl();
      const response = await baseProxy.postAuthenticatedData(`${apiURL}/user/shakehand`, params.authToken);

      return {
        data: response.error ? null : response,
        isResourceResponding: true,
        error: response.error,
      };
    } catch (error) {
      return {
        data: null,
        isResourceResponding: false,
        error,
      };
    }
  }
}
